import React from 'react';

import { currencyFormat } from 'utilities/common';

export const Table = ({ data }) => {
  if (!data) {
    return (
      <div className="row">
        <div className="empty col-lg-12 truck">
          <div className="truck-wrapper">
            <div className="truck">
              <div className="truck-container"></div>
              <div className="glases"></div>
              <div className="bonet"></div>
              <div className="base"></div>
              <div className="base-aux"></div>
              <div className="wheel-back"></div>
              <div className="wheel-front"></div>
              <div className="smoke"></div>
            </div>
          </div>
          <p className="empty-title">Aging Customer not found.</p>
        </div>
      </div>
    )
  }

  return (
    <div className="table-responsive m-0 table-overflow">
      <table
        className="table table-vcenter card-table datatable border-bottom"
        width="100%"
      >
        <thead>
          <tr>
            <th
              className="text-start border-end"
              style={{ whiteSpace: 'initial'}}
            >
              Kode#
            </th>
            <th
              className="text-start border-end"
              style={{ whiteSpace: 'initial'}}
            >
              Periode
            </th>
            <th
              className="text-start border-end"
              style={{ whiteSpace: 'initial'}}
            >
              Invoice Date
            </th>
            <th
              className="text-start border-end"
              style={{ whiteSpace: 'initial'}}
            >
              Due Date
            </th>
            <th
              className="text-start border-end"
              style={{ whiteSpace: 'initial'}}
            >
              Aging
            </th>
            <th
              className="text-end border-end"
              style={{ whiteSpace: 'initial'}}
            >
              Acc.Receivable
            </th>
            <th
              className="text-end border-end"
              style={{ whiteSpace: 'initial'}}
            >
              Payment
            </th>
            <th
              className="text-start border-end"
              style={{ whiteSpace: 'initial'}}
            >
              Payment Date
            </th>
            <th
              className="text-end border-end"
              style={{ whiteSpace: 'initial'}}
            >
              OS
            </th>
          </tr>
        </thead>
        <tbody className="bg-white graph">
          {data?.agging_report?.map((d, i) => (
            <tr key={`${i}`}>
              <td className="border-end">
                <div className="text-ellipsis fw-semibold text-uppercase">
                  {d?.code}
                </div>
              </td>
              <td className="border-end">
                <div className="text-ellipsis text-uppercase">
                  {d?.periode_project}
                </div>
              </td>
              <td className="border-end">
                <div className="text-ellipsis text-uppercase">
                  {d?.schedule_at}
                </div>
              </td>
              <td className="border-end">
                <div className="text-ellipsis text-uppercase">
                  {d?.due_at}
                </div>
              </td>
              <td className="border-end">
                <div className="text-ellipsis text-uppercase">
                  {d?.aging}
                </div>
              </td>
              <td className="border-end text-end">
                <div className="text-ellipsis fw-semibold text-uppercase">
                {currencyFormat(d?.acc_receivable)}
                </div>
              </td>
              <td className="border-end text-end">
                <div className="text-ellipsis fw-semibold text-uppercase">
                {currencyFormat(d?.total_paid || 0)}
                </div>
              </td>
              <td className="border-end">
                <div className="text-ellipsis text-uppercase">
                  {d?.payment_date}
                </div>
              </td>
              <td className="border-end text-end">
                <div className="text-ellipsis fw-semibold text-uppercase">
                {currencyFormat(d?.total_charges || 0)}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};